import { Buffer } from "buffer";
export const zeroBytes = () => Buffer.alloc(0);
export const hexToBytes = (hex) => Buffer.from(hex, "hex");
export const bytesToHex = (bytes) => Buffer.from(bytes).toString("hex");
export const utf8ToBytes = (utf8) => Buffer.from(utf8, "utf8");
export const bytesToUtf8 = (bytes) => Buffer.from(bytes).toString("utf8");
export const utf8ToHex = (utf8) => bytesToHex(utf8ToBytes(utf8));
export const hexToUtf8 = (hex) => bytesToUtf8(hexToBytes(hex));
//# sourceMappingURL=buffer.js.map